import React from "react";
import { useTheme } from "@mui/material";
import CodeMirror from "@uiw/react-codemirror";
import { javascript } from "@codemirror/lang-javascript";

const formatCode = (payload: string | object): string|undefined => {
  const objectToStringify = typeof payload === "object"
    ? payload
    : payload
      ? JSON.parse(payload)
      : "";
  return JSON.stringify(objectToStringify, null, 2);
};

export const RenderObject: React.FC<{ payload?: string | null | object }> = ({ payload }) => {
  const theme = useTheme();

  try {
    if (!payload) return null;
    return <CodeMirror
      editable={false}
      theme={theme.palette.mode}
      extensions={[javascript()]}
      value={formatCode(payload)}
    />;
  } catch (e) {
    return <CodeMirror
      editable={false}
      theme={theme.palette.mode}
      extensions={[javascript()]}
      value="Unexpected Error"
    />;
  }
};

export type NativeRequest = {
  method: string;
  url: string;
  requestBody: any;
  responseBody: any;
}

export const RenderNativeRequests: React.FC<{ payload: string }> = ({ payload }) => {
  const theme = useTheme();
  const data = JSON.parse(payload) as NativeRequest[];
  console.log("Data: ", data);

  return data.map(request => (<CodeMirror
    editable={false}
    theme={theme.palette.mode}
    extensions={[javascript()]}
    value={`${request.method} ${request.url} \nRequest: ${formatCode(request.requestBody)} \nResponse: ${formatCode(request.responseBody)}`}
  />));
};
